// export default PageSpeedPage;
// // src/components/BrandAudit/Step6_PageSpeed.jsx
// import React, { useState, useEffect } from 'react';

// const CACHE_TTL = 24 * 60 * 60 * 1000;

// // Helper: clean domain
// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// // Helper: get page speed data from cache
// const getPageSpeedData = (domain) => {
//   const cacheKey = `pageSpeedRaw_${domain}`;
//   const cached = localStorage.getItem(cacheKey);
//   if (cached) {
//     const { timestamp, data } = JSON.parse(cached);
//     if (Date.now() - timestamp < CACHE_TTL) return data;
//   }
//   return null;
// };

// // Helper: get metric value for a device (mobile or desktop)
// const getMetric = (data, device, metricPath, defaultValue = 0) => {
//   if (!data) return defaultValue;
//   const deviceData = data[device];
//   if (!deviceData) return defaultValue;
//   const pathParts = metricPath.split('.');
//   let value = deviceData;
//   for (const part of pathParts) {
//     if (value && typeof value === 'object') value = value[part];
//     else { value = defaultValue; break; }
//   }
//   return typeof value === 'number' ? value : defaultValue;
// };

// // Helper: format seconds
// const formatSeconds = (ms) => (ms / 1000).toFixed(1) + 's';

// // Helper: get dot class for a metric
// const getMetricDotClass = (value, thresholds) => {
//   if (value >= thresholds.good) return 'dot-good';
//   if (value >= thresholds.warn) return 'dot-warn';
//   return 'dot-bad';
// };

// // Helper: get score dot class (higher = better)
// const getScoreDotClass = (score) => {
//   if (score >= 90) return 'dot-good';
//   if (score >= 50) return 'dot-warn';
//   return 'dot-bad';
// };

// const avatarColors = ['#6B4FA0', '#E05C4B', '#0D9488', '#1A73E8', '#C47D1A'];

// const PageSpeedPage = ({ brandName, websiteUrl, competitors, onContinue }) => {
//   const [loading, setLoading] = useState(true);
//   const [device, setDevice] = useState('mobile');
//   const [rows, setRows] = useState([]);
//   const [insightText, setInsightText] = useState('');

//   // Check if all required page speed data is cached
//   const isDataReady = () => {
//     const brandDomain = cleanDomain(websiteUrl);
//     if (!getPageSpeedData(brandDomain)) return false;
//     for (const comp of competitors) {
//       const compDomain = cleanDomain(comp.website);
//       if (compDomain && !getPageSpeedData(compDomain)) return false;
//     }
//     return true;
//   };

//   // Build rows for all entities
//   const buildTable = () => {
//     const brandDomain = cleanDomain(websiteUrl);
//     const brandData = getPageSpeedData(brandDomain);
//     const allRows = [
//       {
//         domain: brandDomain,
//         name: brandName,
//         isBrand: true,
//         color: avatarColors[0],
//         data: brandData,
//       },
//       ...competitors.map((comp, idx) => {
//         const domain = cleanDomain(comp.website);
//         const data = getPageSpeedData(domain);
//         return {
//           domain,
//           name: comp.name || domain || 'Competitor',
//           isBrand: false,
//           color: avatarColors[(idx + 1) % avatarColors.length],
//           data,
//         };
//       }),
//     ].filter(row => row.data); // only rows with data

//     setRows(allRows);
//     generateInsight(allRows);
//   };

//   // Generate insight based on current device
//   const generateInsight = (rowsData) => {
//     const brandRow = rowsData.find(r => r.isBrand);
//     if (!brandRow) return;
//     const brandPerf = getMetric(brandRow.data, device, 'performance_score', 0);
//     const compPerfs = rowsData.filter(r => !r.isBrand).map(r => getMetric(r.data, device, 'performance_score', 0));
//     const avgComp = compPerfs.length ? compPerfs.reduce((a,b) => a+b,0)/compPerfs.length : 0;
//     let insight = '';
//     if (brandPerf >= 90) {
//       insight = `<strong>${brandName}</strong> has excellent ${device} performance (${brandPerf}/100), ahead of competitors. `;
//     } else if (brandPerf >= 50) {
//       insight = `<strong>${brandName}</strong> scores ${brandPerf}/100 on ${device} – rated <span class="chip-warn">Needs Improvement</span>. `;
//       if (avgComp > brandPerf + 10) {
//         insight += `Competitors average ${avgComp.toFixed(0)} – you are lagging behind. `;
//       }
//     } else {
//       insight = `<strong>${brandName}</strong> has poor ${device} performance (${brandPerf}/100) – this hurts UX and SEO. `;
//     }
//     const lcp = getMetric(brandRow.data, device, 'largest_contentful_paint', 0);
//     if (lcp > 4000) insight += `LCP at ${formatSeconds(lcp)} is very slow. `;
//     else if (lcp > 2500) insight += `LCP at ${formatSeconds(lcp)} needs improvement. `;
//     const cls = getMetric(brandRow.data, device, 'cumulative_layout_shift', 0);
//     if (cls > 0.25) insight += `CLS at ${cls.toFixed(3)} is high – layout shifts degrade experience. `;
//     setInsightText(insight);
//   };

//   // Poll until data ready, then build
//   useEffect(() => {
//     const checkAndBuild = () => {
//       if (isDataReady()) {
//         buildTable();
//         setLoading(false);
//       } else {
//         setTimeout(checkAndBuild, 500);
//       }
//     };
//     checkAndBuild();
//   }, [websiteUrl, competitors]);

//   // Re‑generate insight when device changes
//   useEffect(() => {
//     if (rows.length) generateInsight(rows);
//   }, [device, rows]);

//   if (loading) {
//     return (
//       <div className="card" id="card-6">
//         <div className="eyebrow">Page Speed Audit</div>
//         <h2 className="ctitle">Performance & Core Web Vitals</h2>
//         <p className="cdesc">Google PageSpeed scores — brand and competitors side by side across all parameters.</p>
//         <div className="ps-fetch show">
//           <div className="spinner" />
//           <span>Running PageSpeed analysis on all domains…</span>
//         </div>
//       </div>
//     );
//   }

//   // Metrics definition (matches static HTML columns)
//   const metrics = [
//     { key: 'performance_score', label: 'Performance', hint: 'Score /100', type: 'score', good: 90, warn: 50, unit: '', divideBy: 1 },
//     { key: 'accessibility_score', label: 'Accessibility', hint: 'Score /100', type: 'score', good: 90, warn: 50, unit: '', divideBy: 1 },
//     { key: 'best_practices_score', label: 'Best Practices', hint: 'Score /100', type: 'score', good: 90, warn: 50, unit: '', divideBy: 1 },
//     { key: 'seo_score', label: 'SEO', hint: 'Score /100', type: 'score', good: 90, warn: 50, unit: '', divideBy: 1 },
//     { key: 'first_contentful_paint', label: 'FCP', hint: 'First Contentful Paint', type: 'cwv', good: 1800, warn: 3000, unit: 's', divideBy: 1000 },
//     { key: 'largest_contentful_paint', label: 'LCP', hint: 'Largest Contentful Paint', type: 'cwv', good: 2500, warn: 4000, unit: 's', divideBy: 1000 },
//     { key: 'cumulative_layout_shift', label: 'CLS', hint: 'Cumulative Layout Shift', type: 'cwv', good: 0.1, warn: 0.25, unit: '', divideBy: 1 },
//     { key: 'total_blocking_time', label: 'TBT', hint: 'Total Blocking Time', type: 'cwv', good: 200, warn: 600, unit: 'ms', divideBy: 1 },
//     { key: 'speed_index', label: 'Speed Index', hint: 'Overall Speed Index', type: 'cwv', good: 3400, warn: 5800, unit: 's', divideBy: 1000 },
//     { key: 'server_response_time', label: 'TTFB', hint: 'Server Response Time', type: 'cwv', good: 200, warn: 600, unit: 'ms', divideBy: 1 },
//   ];

//   // Compute winners per metric for the current device
//   const winners = {};
//   for (const m of metrics) {
//     let bestValue = m.type === 'score' ? -1 : Infinity;
//     let bestRow = null;
//     for (const row of rows) {
//       let val = getMetric(row.data, device, m.key, 0);
//       if (m.type === 'score') {
//         if (val > bestValue) { bestValue = val; bestRow = row; }
//       } else {
//         if (val < bestValue && val > 0) { bestValue = val; bestRow = row; }
//       }
//     }
//     winners[m.key] = bestRow ? bestRow.name : '';
//   }

//   return (
//     <div className="card" id="card-6">
//       <div className="eyebrow">Page Speed Audit</div>
//       <h2 className="ctitle">Performance & Core Web Vitals</h2>
//       <p className="cdesc">Google PageSpeed scores — brand and competitors side by side across all parameters.</p>

//       {/* <div className="c6-dev">
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="#8B6DBF">
//           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
//         </svg>
//         <span><strong>Developer note:</strong> Google PageSpeed Insights API — metrics for both desktop and mobile.</span>
//       </div> */}

//       {/* Device toggle */}
//       <div className="device-toggle">
//         <button className={`dtab ${device === 'mobile' ? 'active' : ''}`} onClick={() => setDevice('mobile')}>
//           <svg viewBox="0 0 24 24"><path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/></svg>
//           Mobile
//         </button>
//         <button className={`dtab ${device === 'desktop' ? 'active' : ''}`} onClick={() => setDevice('desktop')}>
//           <svg viewBox="0 0 24 24"><path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v1h12v-1l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/></svg>
//           Desktop
//         </button>
//       </div>

//       <div className="scroll-hint">
//         <svg viewBox="0 0 24 24"><path d="M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"/></svg>
//         Scroll to see all metrics
//       </div>

//       <div className="seo-legend" style={{ marginBottom: 12 }}>
//         <div className="legend-item"><div className="metric-dot dot-good"></div> Good</div>
//         <div className="legend-item"><div className="metric-dot dot-warn"></div> Needs Improvement</div>
//         <div className="legend-item"><div className="metric-dot dot-bad"></div> Poor</div>
//         <div className="legend-item"><span className="crown">👑</span> Best in column</div>
//       </div>

//       <div className="seo-scroll-outer">
//         <div className="seo-table-container">
//           <table className="seo-table">
//             <thead>
//               <tr>
//                 <th>Brand / Competitor</th>
//                 {metrics.map(m => <th key={m.key}>{m.label}<span className="metric-hint">{m.hint}</span></th>)}
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((row, idx) => {
//                 const initials = row.name.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?';
//                 return (
//                   <tr key={row.domain} className={row.isBrand ? 'brand-row' : ''}>
//                     <td>
//                       <div className="entity-cell">
//                         <div className="entity-avatar" style={{ background: row.color }}>{initials}</div>
//                         <div>
//                           <div className="entity-name">{row.name}</div>
//                           <div className="entity-type">{row.isBrand ? 'Your Brand' : 'Competitor'}</div>
//                         </div>
//                       </div>
//                     </td>
//                     {metrics.map(m => {
//                       let rawValue = getMetric(row.data, device, m.key, 0);
//                       let displayValue = rawValue;
//                       if (m.unit === 's' && m.divideBy) displayValue = (rawValue / m.divideBy).toFixed(1);
//                       else if (m.unit === 'ms') displayValue = Math.round(rawValue);
//                       else if (m.type === 'score') displayValue = Math.round(rawValue);
//                       else if (m.type !== 'score') displayValue = rawValue.toFixed(2);
                      
//                       const isWinner = winners[m.key] === row.name;
//                       const dotClass = m.type === 'score' 
//                         ? getScoreDotClass(rawValue)
//                         : getMetricDotClass(rawValue, { good: m.good, warn: m.warn });
//                       return (
//                         <td key={m.key} className={isWinner ? 'winner-cell' : ''}>
//                           <div className="metric-val">
//                             <span className="metric-num">{displayValue}{isWinner && ' 👑'}</span>
//                             <div className={`metric-dot ${dotClass}`}></div>
//                           </div>
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className="insight-box">
//         <div className="insight-header">
//           <div className="insight-title">
//             <svg viewBox="0 0 24 24"><path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/></svg>
//             Page Speed Insight
//           </div>
//           <button className="play-btn" onClick={() => {
//             const utterance = new SpeechSynthesisUtterance(insightText.replace(/<[^>]*>/g, ''));
//             utterance.lang = 'en-IN';
//             speechSynthesis.speak(utterance);
//           }}>
//             <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
//             Play
//           </button>
//         </div>
//         <div className="insight-text" dangerouslySetInnerHTML={{ __html: insightText }} />
//       </div>

//       <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
//         Continue to Technical SEO
//         <svg viewBox="0 0 24 24" fill="white"><path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/></svg>
//       </button>
//     </div>
//   );
// };

// export default PageSpeedPage;
// src/components/BrandAudit/Step6_PageSpeed.jsx
import React, { useState, useEffect, useRef } from 'react';
import { normalizeBrandName } from '../../utils/normalizeBrandName';
import { GoogleGenerativeAI } from '@google/generative-ai';
import { auditAPI } from '../../services/api';

const CACHE_TTL = 24 * 60 * 60 * 1000;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

// Helper: clean domain
const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// Helper: get page speed data from cache
const getPageSpeedData = (domain) => {
  const cacheKey = `pageSpeedRaw_${domain}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    const { timestamp, data } = JSON.parse(cached);
    if (Date.now() - timestamp < CACHE_TTL) return data;
  }
  return null;
};

// Helper: get metric value for a device (mobile or desktop)
const getMetric = (data, device, metricPath, defaultValue = 0) => {
  if (!data) return defaultValue;
  const deviceData = data[device];
  if (!deviceData) return defaultValue;
  const pathParts = metricPath.split('.');
  let value = deviceData;
  for (const part of pathParts) {
    if (value && typeof value === 'object') value = value[part];
    else { value = defaultValue; break; }
  }
  return typeof value === 'number' ? value : defaultValue;
};

// Helper: format seconds
const formatSeconds = (ms) => (ms / 1000).toFixed(1) + 's';

// Helper: get dot class for a metric
const getMetricDotClass = (value, thresholds) => {
  if (value >= thresholds.good) return 'dot-good';
  if (value >= thresholds.warn) return 'dot-warn';
  return 'dot-bad';
};

// Helper: get score dot class (higher = better)
const getScoreDotClass = (score) => {
  if (score >= 90) return 'dot-good';
  if (score >= 50) return 'dot-warn';
  return 'dot-bad';
};

const avatarColors = ['#6B4FA0', '#E05C4B', '#0D9488', '#1A73E8', '#C47D1A'];

// ─────────────────────────────────────────────────────────────────────────
// Gemini API wrapper
// ─────────────────────────────────────────────────────────────────────────
const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

const callGemini = async (prompt) => {
  if (!GEMINI_API_KEY) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
  try {
    const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
    const result = await model.generateContent(prompt);
    const response = await result.response;
    return response.text();
  } catch (error) {
    console.error('Gemini SDK error:', error);
    throw new Error('Gemini API request failed');
  }
};

const INSIGHT_TTL = 24 * 60 * 60 * 1000;

const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight', autoGenerate = true }) => {
  const [aiText, setAiText] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState('');
  const generatedRef = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const utteranceRef = useRef(null);

  useEffect(() => {
    return () => window.speechSynthesis.cancel();
  }, []);

  useEffect(() => {
    if (!cacheKey) return;
    try {
      const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
      if (cached) {
        const { ts, text } = JSON.parse(cached);
        if (Date.now() - ts < INSIGHT_TTL && text) {
          setAiText(text);
          return;
        }
      }
    } catch {}
    if (autoGenerate && !generatedRef.current) {
      generatedRef.current = true;
      generate();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  const generate = async () => {
    if (!prompt) return;
    setAiLoading(true);
    setAiError('');
    try {
      const text = await callGemini(prompt);
      setAiText(text);
      if (cacheKey) {
        localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
      }
    } catch (e) {
      setAiError('Could not generate insight. Check your API key and try again.');
      console.error(e);
    } finally {
      setAiLoading(false);
    }
  };

  const togglePlayback = () => {
    const synth = window.speechSynthesis;
    if (isPlaying) {
      synth.pause();
      setIsPlaying(false);
      setIsPaused(true);
    } else {
      if (isPaused && synth.paused) {
        synth.resume();
        setIsPlaying(true);
        setIsPaused(false);
      } else {
        synth.cancel();
        const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
        utterance.lang = 'en-IN';
        utterance.onend  = () => { setIsPlaying(false); setIsPaused(false); };
        utterance.onerror = () => { setIsPlaying(false); setIsPaused(false); };
        utteranceRef.current = utterance;
        synth.speak(utterance);
        setIsPlaying(true);
        setIsPaused(false);
      }
    }
  };

  return (
    <div className="insight-box" style={{ marginTop: 20 }}>
      <div className="insight-header">
        <div className="insight-title">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
          </svg>
          {title}
        </div>
        {aiText && !aiLoading && (
          <button className="play-btn" onClick={togglePlayback}>
            <svg viewBox="0 0 24 24" width="12" height="12">
              {isPlaying
                ? <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                : <path d="M8 5v14l11-7z" />}
            </svg>
            {isPlaying ? 'Pause' : 'Play'}
          </button>
        )}
      </div>
      {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight…</div>}
      {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
      {aiText && !aiLoading && <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>}
      {!aiText && !aiLoading && !aiError && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>AI insight will appear here shortly.</div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────
const PageSpeedPage = ({ brandName, websiteUrl, competitors, onContinue }) => {
  const [loading, setLoading] = useState(true);
  const [device, setDevice] = useState('mobile');
  const [rows, setRows] = useState([]);
  const [brandMobileMetrics, setBrandMobileMetrics] = useState(null);
  const [brandDesktopMetrics, setBrandDesktopMetrics] = useState(null);

const cachePageSpeed = (domain, pageData) => {
  try {
    const cacheKey = `pageSpeedRaw_${domain}`;
    if (pageData) {
      localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: pageData }));
    }
  } catch (e) {
    console.warn('Cache PageSpeed failed', e);
  }
};

const fetchAndCachePageSpeed = async (domain) => {
  try {
    const res = await auditAPI.pagespeedAnalysis({ domain });
    
    // ✅ FIX: unwrap axios .data, then API's .data wrapper
    const responseBody = res?.data?.data || res?.data || {};
    
    // API stores by full URL, not bare domain
    const urlKey = `https://${domain}`;
    const pageData = responseBody[urlKey] || responseBody[domain] || Object.values(responseBody)[0];
    
    if (pageData) {
      cachePageSpeed(domain, pageData);
      return pageData;
    }
  } catch (e) {
    console.warn(`❌ PageSpeed fetch failed for ${domain}:`, e);
  }
  return null;
};

// useEffect(() => {
//   let cancelled = false;

//   const run = async () => {
//     const brandDomain = cleanDomain(websiteUrl);
//     const allDomains = [
//       brandDomain,
//       ...competitors.map(c => cleanDomain(c.website)).filter(Boolean),
//     ];

//     // Fetch all missing domains in parallel, failures return null
//     await Promise.all(
//       allDomains.map(async (domain) => {
//         if (!domain) return;
//         if (getPageSpeedData(domain)) {
//           console.log(`⚡ Cache hit: ${domain}`);
//           return;
//         }
//         console.log(`🔄 Fetching: ${domain}`);
//         await fetchAndCachePageSpeed(domain); // null on failure, that's ok
//       })
//     );

//     if (cancelled) return;

//     // Build table with whatever data we have — don't require 100% success
//     const brandData = getPageSpeedData(brandDomain);
//     if (brandData) {
//       setBrandMobileMetrics(brandData.mobile || {});
//       setBrandDesktopMetrics(brandData.desktop || {});
//     }

//     const normalizedBrand = normalizeBrandName(brandName);
//     const allRows = [
//       {
//         domain: brandDomain,
//         name: normalizedBrand,
//         isBrand: true,
//         color: avatarColors[0],
//         data: brandData,
//       },
//       ...competitors.map((comp, idx) => {
//         const domain = cleanDomain(comp.website);
//         const data = getPageSpeedData(domain);
//         return {
//           domain,
//           name: normalizeBrandName(comp.name || domain || 'Competitor'),
//           isBrand: false,
//           color: avatarColors[(idx + 1) % avatarColors.length],
//           data,
//         };
//       }),
//     ].filter(row => row.domain && row.data); // only drop truly empty rows

//     setRows(allRows);
//     setLoading(false);
//   };

//   const fallback = setTimeout(() => {
//     if (!cancelled) setLoading(false);
//   }, 25000);

//   run();

//   return () => {
//     cancelled = true;
//     clearTimeout(fallback);
//   };
// }, [websiteUrl, competitors, brandName]);

useEffect(() => {
  let cancelled = false;

  const run = async () => {
    const brandDomain = cleanDomain(websiteUrl);
    const allDomains = [
      brandDomain,
      ...competitors.map(c => cleanDomain(c.website)).filter(Boolean),
    ];

    // Fetch all missing domains in parallel
    await Promise.all(
      allDomains.map(async (domain) => {
        if (!domain) return;
        if (getPageSpeedData(domain)) {
          console.log(`⚡ Cache hit: ${domain}`);
          return;
        }
        console.log(`🔄 Fetching: ${domain}`);
        await fetchAndCachePageSpeed(domain);
      })
    );

    if (cancelled) return;

    // Build rows
    const brandData = getPageSpeedData(brandDomain);
    if (brandData) {
      setBrandMobileMetrics(brandData.mobile || {});
      setBrandDesktopMetrics(brandData.desktop || {});
    }

    const normalizedBrand = normalizeBrandName(brandName);
    const allRows = [
      {
        domain: brandDomain,
        name: normalizedBrand,
        isBrand: true,
        color: avatarColors[0],
        data: brandData,
      },
      ...competitors.map((comp, idx) => {
        const domain = cleanDomain(comp.website);
        const data = getPageSpeedData(domain);
        return {
          domain,
          name: normalizeBrandName(comp.name || domain || 'Competitor'),
          isBrand: false,
          color: avatarColors[(idx + 1) % avatarColors.length],
          data,
        };
      }),
    ].filter(row => row.domain && row.data);

    if (cancelled) return;

    // ── Only hide loading AFTER rows are set ──
    setRows(allRows);
    setLoading(false);  // ← moved here, after setRows
  };

  // ── Fallback: show whatever we have after 90s ──
  const fallback = setTimeout(() => {
    if (!cancelled) {
      const brandDomain = cleanDomain(websiteUrl);
      const brandData = getPageSpeedData(brandDomain);
      const allRows = [
        {
          domain: brandDomain,
          name: normalizeBrandName(brandName),
          isBrand: true,
          color: avatarColors[0],
          data: brandData,
        },
        ...competitors.map((comp, idx) => {
          const domain = cleanDomain(comp.website);
          return {
            domain,
            name: normalizeBrandName(comp.name || domain || 'Competitor'),
            isBrand: false,
            color: avatarColors[(idx + 1) % avatarColors.length],
            data: getPageSpeedData(domain),
          };
        }),
      ].filter(row => row.domain && row.data);

      setRows(allRows);
      setLoading(false);
    }
  }, 90000);

  run();

  return () => {
    cancelled = true;
    clearTimeout(fallback);
  };
}, [websiteUrl, competitors, brandName]);

  const metrics = [
    { key: 'performance_score',       label: 'Performance',   hint: 'Score /100',               type: 'score', good: 90,   warn: 50,   unit: '',  divideBy: 1    },
    { key: 'accessibility_score',     label: 'Accessibility', hint: 'Score /100',               type: 'score', good: 90,   warn: 50,   unit: '',  divideBy: 1    },
    { key: 'best_practices_score',    label: 'Best Practices',hint: 'Score /100',               type: 'score', good: 90,   warn: 50,   unit: '',  divideBy: 1    },
    { key: 'seo_score',               label: 'SEO',           hint: 'Score /100',               type: 'score', good: 90,   warn: 50,   unit: '',  divideBy: 1    },
    { key: 'first_contentful_paint',  label: 'FCP',           hint: 'First Contentful Paint',   type: 'cwv',   good: 1800, warn: 3000, unit: 's', divideBy: 1000 },
    { key: 'largest_contentful_paint',label: 'LCP',           hint: 'Largest Contentful Paint', type: 'cwv',   good: 2500, warn: 4000, unit: 's', divideBy: 1000 },
    { key: 'cumulative_layout_shift', label: 'CLS',           hint: 'Cumulative Layout Shift',  type: 'cwv',   good: 0.1,  warn: 0.25, unit: '',  divideBy: 1    },
    { key: 'total_blocking_time',     label: 'TBT',           hint: 'Total Blocking Time',      type: 'cwv',   good: 200,  warn: 600,  unit: 'ms',divideBy: 1    },
    { key: 'speed_index',             label: 'Speed Index',   hint: 'Overall Speed Index',      type: 'cwv',   good: 3400, warn: 5800, unit: 's', divideBy: 1000 },
    { key: 'server_response_time',    label: 'TTFB',          hint: 'Server Response Time',     type: 'cwv',   good: 200,  warn: 600,  unit: 'ms',divideBy: 1    },
  ];

  const winners = {};
  for (const m of metrics) {
    let bestValue = m.type === 'score' ? -1 : Infinity;
    let bestRow = null;
    for (const row of rows) {
      const val = getMetric(row.data, device, m.key, 0);
      if (m.type === 'score') {
        if (val > bestValue) { bestValue = val; bestRow = row; }
      } else {
        if (val < bestValue && val > 0) { bestValue = val; bestRow = row; }
      }
    }
    winners[m.key] = bestRow ? bestRow.name : '';
  }

  // ── FIX: null-safe metric extraction using != null (catches both null and undefined) ──
  const buildPerformancePrompt = (deviceType) => {
    const metricsData = deviceType === 'mobile' ? brandMobileMetrics : brandDesktopMetrics;
    if (!metricsData) return '';

    // ?? 0  — falls back only on null/undefined, not on a real 0 score
    // != null — catches both null and undefined, preventing .toFixed() / Math.round() crashes
    const perf = metricsData.performance_score   ?? 0;
    const acc  = metricsData.accessibility_score ?? 0;
    const seo  = metricsData.seo_score           ?? 0;

    const fcp  = metricsData.first_contentful_paint  != null
      ? formatSeconds(metricsData.first_contentful_paint)
      : 'N/A';

    // OLD (crashes when value is null): metricsData.cumulative_layout_shift !== undefined ? ...toFixed(3)
    // FIX: != null guards against null AND undefined; Number() ensures it's a primitive before toFixed
    const cls  = metricsData.cumulative_layout_shift != null
      ? Number(metricsData.cumulative_layout_shift).toFixed(3)
      : 'N/A';

    const tbt  = metricsData.total_blocking_time  != null
      ? `${Math.round(metricsData.total_blocking_time)}ms`
      : 'N/A';

    const tti  = metricsData.time_to_interactive  != null
      ? formatSeconds(metricsData.time_to_interactive)
      : 'N/A';

    const si   = metricsData.speed_index          != null
      ? formatSeconds(metricsData.speed_index)
      : 'N/A';

    const ttfb = metricsData.server_response_time != null
      ? `${Math.round(metricsData.server_response_time)}ms`
      : 'N/A';

    return `You are a senior web performance strategist preparing a professional brand audit report. Business-appropriate language. No unexplained technical jargon. No bullet points. Maximum 3 sentences.

Brand: ${brandName}
Device: ${deviceType === 'mobile' ? 'Mobile' : 'Desktop'}
Performance Score: ${perf}/100
Accessibility Score: ${acc}/100
SEO Score: ${seo}/100
First Contentful Paint (FCP): ${fcp}
Cumulative Layout Shift (CLS): ${cls}
Total Blocking Time (TBT): ${tbt}
Time to Interactive (TTI): ${tti}
Speed Index: ${si}
Server Response Time (TTFB): ${ttfb}

Provide a professional assessment of this brand's ${deviceType === 'mobile' ? 'mobile' : 'desktop'} web performance. Translate the technical metrics into clear business impact — specifically how page speed affects customer retention and search ranking. Identify the highest‑priority metric requiring remediation.`;
  };

  const mobilePrompt  = buildPerformancePrompt('mobile');
  const desktopPrompt = buildPerformancePrompt('desktop');
  const currentPrompt = device === 'mobile' ? mobilePrompt : desktopPrompt;
  const currentCacheKey = `pagespeed_insight_${cleanDomain(websiteUrl)}_${device}`;

  if (loading) {
  return (
    <div className="card" id="card-6">
      <div className="eyebrow">Page Speed Audit</div>
      <h2 className="ctitle">Performance & Core Web Vitals</h2>
      <p className="cdesc">Measure how your website performs on speed within your competitive landscape.</p>
      <div className="ps-fetch show">
        <div className="spinner" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span>Running PageSpeed analysis on all domains…</span>
          <span style={{ fontSize: 12, color: '#888' }}>
            Analysing {competitors.length + 1} domain{competitors.length > 0 ? 's' : ''} — this takes 30–60 seconds
          </span>
        </div>
      </div>
    </div>
  );
}

  return (
    <div className="card" id="card-6">
      <div className="eyebrow">Page Speed Audit</div>
      <h2 className="ctitle">Performance & Core Web Vitals</h2>
      <p className="cdesc">Measure how your website performs on speed within your competitive landscape.</p>

      {/* Device toggle */}
      <div className="device-toggle">
        <button className={`dtab ${device === 'mobile' ? 'active' : ''}`} onClick={() => setDevice('mobile')}>
          <svg viewBox="0 0 24 24">
            <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" />
          </svg>
          Mobile
        </button>
        <button className={`dtab ${device === 'desktop' ? 'active' : ''}`} onClick={() => setDevice('desktop')}>
          <svg viewBox="0 0 24 24">
            <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v1h12v-1l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z" />
          </svg>
          Desktop
        </button>
      </div>

      <div className="scroll-hint">
        <svg viewBox="0 0 24 24">
          <path d="M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z" />
        </svg>
        Scroll to see all metrics
      </div>

      <div className="seo-legend" style={{ marginBottom: 12 }}>
        <div className="legend-item"><div className="metric-dot dot-good" /></div> Good
        <div className="legend-item"><div className="metric-dot dot-warn" /></div> Needs Improvement
        <div className="legend-item"><div className="metric-dot dot-bad" /></div> Poor
        <div className="legend-item"><span className="crown">👑</span> Best in column</div>
      </div>

      <div className="seo-scroll-outer">
        <div className="seo-table-container">
          <table className="seo-table">
            <thead>
              <tr>
                <th>Brand / Competitor</th>
                {metrics.map(m => (
                  <th key={m.key}>{m.label}<span className="metric-hint">{m.hint}</span></th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => {
                const initials = row.name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';
                return (
                  <tr key={row.domain} className={row.isBrand ? 'brand-row' : ''}>
                    <td>
                      <div className="entity-cell">
                        <div className="entity-avatar" style={{ background: row.color }}>{initials}</div>
                        <div>
                          <div className="entity-name">{row.name}</div>
                          <div className="entity-type">{row.isBrand ? 'Your Brand' : 'Competitor'}</div>
                        </div>
                      </div>
                    </td>
                    {metrics.map(m => {
                      const rawValue = getMetric(row.data, device, m.key, 0);
                      let displayValue;
                      if (m.unit === 's' && m.divideBy)  displayValue = (rawValue / m.divideBy).toFixed(1);
                      else if (m.unit === 'ms')           displayValue = Math.round(rawValue);
                      else if (m.type === 'score')        displayValue = Math.round(rawValue);
                      else                                displayValue = rawValue.toFixed(2);
                      const isWinner = winners[m.key] === row.name;
                      const dotClass = m.type === 'score'
                        ? getScoreDotClass(rawValue)
                        : getMetricDotClass(rawValue, { good: m.good, warn: m.warn });
                      return (
                        <td key={m.key} className={isWinner ? 'winner-cell' : ''}>
                          <div className="metric-val">
                            <span className="metric-num">{displayValue}{isWinner && ' 👑'}</span>
                            <div className={`metric-dot ${dotClass}`} />
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {currentPrompt && (
        <AIInsightBox
          key={device}
          title={`Page Speed Insight — ${device === 'mobile' ? 'Mobile' : 'Desktop'}`}
          cacheKey={currentCacheKey}
          prompt={currentPrompt}
          autoGenerate={!!GEMINI_API_KEY}
        />
      )}

      <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
        Continue to Technical SEO
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z" />
        </svg>
      </button>
    </div>
  );
};

export default PageSpeedPage;
